// Fix Modernizr flexbox detection for IE 10
if (Modernizr._version[0] === '2') {
    delete Modernizr.flexbox;
    Modernizr.addTest('flexbox', Modernizr.testAllProps('flexBasis', '1px', true));
}
